<template>
    <!--Start Page Banner-->
    <div class="page-banner-area bg-1">
        <div class="container">
            <div class="page-banner-content">
                <h1>Arts Department</h1>
                <ul>
                    <li><a href="/">Home</a></li>
                    <li>Departments</li>
                    <li>Department of Arts</li>
                </ul>
            </div>
        </div>
    </div>
    <!--End Page Banner-->

    <!--Start Courses Details Area-->
    <div class="courses-details-area pt-100 pb-70">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="courses-details">
                        <div class="courses-card">
                            <h2>Degree Offered</h2>
                        </div>
                        <div class="description">
                            <div class="container p-0">
                                <nav>
                                    <div class="nav nav-tabs d-flex justify-content-between" id="nav-tab"
                                        role="tablist">
                                        <button style="width: 50%;" class="nav-link active" id="nav-overview-tab"
                                            data-bs-toggle="tab" data-bs-target="#nav-overview" type="button" role="tab"
                                            aria-controls="nav-overview" aria-selected="true">Bachelor of Arts
                                            (B.A.)</button>

                                        <button style="width: 50%;" class="nav-link" id="nav-curriculum-tab"
                                            data-bs-toggle="tab" data-bs-target="#nav-curriculum" type="button"
                                            role="tab" aria-controls="nav-curriculum" aria-selected="false">Master of
                                            Arts
                                            (M.A.)</button>
                                    </div>
                                </nav>
                                <div class="tab-content" id="nav-tabContent">
                                    <div class="tab-pane fade show active" id="nav-overview" role="tabpanel"
                                        aria-labelledby="nav-overview-tab">
                                        <div class="overview">
                                            <div class="learn">
                                                <h3>Overview</h3>
                                                <p>The Bachelor of Arts (B.A.) is a three-year undergraduate program
                                                    focused on humanities and social sciences. It helps students develop
                                                    critical thinking, communication, and analytical skills. With a wide
                                                    range of subjects like English, History, Political Science, and
                                                    Sociology, the B.A. course prepares students for careers in
                                                    education, media, public service, and more.
                                                </p>
                                            </div>
                                            <div class="learn">
                                                <h3>What you will learn?</h3>
                                                <p>The Bachelor of Arts (B.A.) Pass Course is a three-year undergraduate
                                                    program that offers a comprehensive education in the humanities and
                                                    social sciences. Unlike specialized programs, the Pass Course allows
                                                    students to study two to three subjects equally, providing a
                                                    well-rounded academic foundation. It promotes the development of
                                                    critical thinking, effective communication, and a deeper
                                                    understanding of cultural and social dynamics.
                                                </p>
                                            </div>
                                            <div class="overview-box">
                                                <h4>Learning Outcome</h4>
                                                <ul>
                                                    <li><strong>Broad Knowledge Base:</strong> Understand key concepts
                                                        in humanities and
                                                        social sciences.</li>
                                                    <li><strong>Critical Thinking:</strong> Analyze social, political,
                                                        economic, and
                                                        cultural issues with logical reasoning.</li>
                                                    <li><strong>Effective Communication: </strong>Develop strong
                                                        writing, speaking, and
                                                        presentation skills.</li>
                                                    <li><strong>Cultural Awareness:</strong> Gain awareness of diverse
                                                        cultures,
                                                        traditions, and global perspectives.</li>
                                                    <li><strong>Research Skills:</strong> Learn basic research methods,
                                                        data collection,
                                                        and report writing.</li>
                                                    <li><strong>Ethical Understanding:</strong> Recognize social
                                                        responsibilities and
                                                        ethical values in society.</li>
                                                </ul>
                                            </div>
                                            <div class="overview-box">
                                                <h4>Career Opportunities</h4>
                                                <ul>
                                                    <li>Government Jobs:Eligible for exams like UPSC,
                                                        SSC, State PSC,
                                                        Railways, etc</li>
                                                    <li>Teaching: After completing B.Ed., can apply for
                                                        school teaching
                                                        positions.
                                                    </li>
                                                    <li>Journalism & Media: Work as a reporter,
                                                        content writer, editor,
                                                        or media researcher.
                                                    </li>
                                                    <li>Content Writing: Opportunities in blogging,
                                                        copywriting,
                                                        academic writing, etc.
                                                    </li>
                                                    <li>Public Relations: Work in corporate
                                                        communication, branding, and
                                                        PR agencies.
                                                    </li>
                                                    <li>Social Work & NGOs: Engage in community
                                                        development and welfare
                                                        projects.
                                                    </li>
                                                    <li>Banking & Finance: Apply for clerical and
                                                        officer-level posts in
                                                        banks.
                                                    </li>
                                                    <li>Higher Education: Pursue M.A., MBA, or other
                                                        postgraduate
                                                        degrees.</li>
                                                    <li>Administrative Roles: Office assistants,
                                                        clerks, and
                                                        coordinators in private and public sectors.
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="tab-pane fade" id="nav-curriculum" role="tabpanel"
                                        aria-labelledby="nav-curriculum-tab">
                                        <div class="curriculum">
                                            <div class="overview">
                                                <div class="learn">
                                                    <h3>Overview</h3>
                                                    <p>The Master of Arts (M.A.) is a two-year postgraduate degree that
                                                        offers advanced knowledge in the fields of humanities and social
                                                        sciences. It is designed for students who wish to deepen their
                                                        understanding of a particular subject and enhance their research
                                                        and analytical skills.<br />
                                                        <strong>Subject includes: </strong> English, Political
                                                        Science, Hindi, Public Administration, Drawing & Painting,
                                                        Geography
                                                    </p>
                                                </div>
                                                <div class="learn">
                                                    <h3>What you will learn?</h3>
                                                    <p>A Master of Arts (M.A.) is a postgraduate academic degree awarded
                                                        in fields related to humanities, social sciences. The program
                                                        typically spans 2 years and provides in-depth knowledge and
                                                        analytical skills in a chosen subject area. The learning content
                                                        depends on the specific subject of specialization but generally
                                                        includes:</p>
                                                    <ul>
                                                        <li>Theoretical foundations and critical concepts.</li>
                                                        <li>Advanced research methodologies.</li>
                                                        <li>Analytical and interpretive skills.</li>
                                                        <li>Subject-specific knowledge (e.g., literature, politics,
                                                            sociology).</li>
                                                        <li>Interdisciplinary perspectives.</li>
                                                    </ul>
                                                    
                                                </div>
                                                <div class="overview-box">
                                                    <h4>Learning Outcome</h4>
                                                    <ul>
                                                        <li>Demonstrate comprehensive knowledge in their field of study.
                                                        </li>
                                                        <li>Apply theoretical and analytical frameworks to real-world
                                                            issues.</li>
                                                        <li>Conduct independent academic research.</li>
                                                        <li>Communicate complex ideas effectively, both in writing and
                                                            speech.</li>
                                                        <li>Engage in critical thinking and reflective analysis.</li>
                                                        <li>Prepare for doctoral studies or competitive examinations.
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div class="overview-box">
                                                    <h4>Career Opportunities</h4>
                                                    <ul>
                                                        <li>Academia (Lecturer, Researcher)
                                                        </li>
                                                        <li>Civil Services & Government Jobs
                                                        </li>
                                                        <li>Content Writing & Journalism
                                                        </li>
                                                        <li>Publishing & Editing
                                                        </li>
                                                        <li> Public Relations & Communication
                                                        </li>
                                                        <li>NGOs and International Organizations
                                                        </li>
                                                        <li>Corporate Sector (HR, Management roles)
                                                        </li>
                                                        <li>Further Studies (Ph.D., M. Phil., B.Ed., etc.)
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4" style="display: none;">
                    <div class="related-download">
                        <h3>Related Links</h3>
                        <ul>
                            <li><a href="fees.html"><i class="flaticon-writing-tool"></i>Fees Structure</a></li>
                            <li><a href="eligibility.html"><i class="flaticon-writing-tool"></i>Eligiblity
                                    Criteria</a>
                            </li>
                            <li><a href="../about/campus.html"><i class="flaticon-writing-tool"></i>Campus</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!--End Courses Details Area-->

    <!-- Start Bottom Connect Area -->
    <div class="alumni-interview-area pb-100">
        <div class="container">
            <div class="interview-content ptb-100">
                <div class="interview">
                    <router-link to="/syllabus" class="default-btn btn">Syllabus<i
                            class="flaticon-next"></i></router-link>
                    <router-link to="/applynow" class="default-btn btn">Apply Now</router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "ArtsDeptView"
};
</script>
